<template>
    <div>
        <h1 class="my-5">Login</h1>

        <b-alert
            :show="dismissCountDown"
            dismissible
            :variant="notificationColor"
            @dismissed="dismissCountDown=0"
            @dismiss-count-down="countDownChanged"
        >
            {{ notification }}
        </b-alert>

        <div v-if="loading"><img src="/loading.svg"> Loading</div>
        <div v-else>
            <b-alert
                v-if="$auth.user()"
                show="30"
                dismissible
                variant="info"
                class="alert-inline"
            >
                You are already logged in. <router-link to="/">Open dashboard</router-link>
            </b-alert>

            <validation-observer ref="observer" v-slot="{ passes }">
                <form v-on:submit.prevent="passes(login)">
                    <label>Email</label>
                    <validation-provider name="email" rules="email|required" v-slot="{ errors }">
                        <b-form-input type="email" autocomplete="username" v-model="email"></b-form-input>
                        <span class="validation">{{ errors[0] }}</span>
                    </validation-provider>

                    <label class="mt-4">Password</label>
                    <validation-provider name="password" rules="min:6|required" v-slot="{ errors }">
                        <b-form-input type="password" autocomplete="current-password" v-model="password"></b-form-input>
                        <span class="validation">{{ errors[0] }}</span>
                        <p class="small text-right m-0"><router-link to="/password/forgot" class="text-body">Forgot password?</router-link></p>
                    </validation-provider>

                    <button type="submit" class="btn btn-success  mt-4">Login</button>
                </form>
            </validation-observer>
        </div>

        <p class="mt-5">No account? <router-link to="/register">Sign up</router-link>.</p>
    </div>
</template>

<script>
    export default {
        data: () => ({
            email: '',
            password: '',
            loading: false,
            notification: null,
            notificationColor: null,
            dismissSecs: 5,
            dismissCountDown: 0,
        }),
        methods: {
            login: function (e) {
                // Using auth.js setup and not regular api
                var redirect = this.$auth.redirect()
                var app = this
                app.loading = true
                this.$auth.login({
                    data: {
                        email: this.email,
                        password: this.password,
                    },
                    staySignedIn: true,
                    fetchUser: true
                })
                    .then(() => { // success

                        this.notify('Logged in', 'success')
                        // auto redirected to '/'

                    }, () => { // error

                        // handle authentication and validation errors here
                        app.loading = false
                        this.notify('Could not login. Incorrect email or password?', 'danger')

                    });
            },
            notify(message, color) {
                this.notification = message
                this.notificationColor = color
                this.dismissCountDown = this.dismissSecs
            },
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
        }
    }
</script>
